<template>
  <div class="item-metatada p-mb-2">
    <p v-if="item.createdAt" class="p-mb-0">
      *Cadastrado em
      {{ $dayjs(item.createdAt).format('DD/MM/YYYY HH:mm') }}
      <span v-if="item.createdBy?.name">por {{ item.createdBy.name }}</span>
    </p>
    <p v-if="item.updatedAt">
      *Atualizado em
      {{ $dayjs(item.updatedAt).format('DD/MM/YYYY HH:mm') }}
      <span v-if="item.updatedBy?.name">por {{ item.updatedBy.name }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ItemMetadata',
  props: {
    item: Object,
  },
};
</script>

<style scoped>
.item-metatada {
  font-size: 0.9rem;
}
</style>